import styled from 'styled-components';
import { font } from '../../styles/typography';

export const FormActions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
`;

const Btn = styled.button`
  padding: 8px 20px;
  border-radius: 6px;
  border: none;
  ${font('base')}
  cursor: pointer;
  font-weight: 500;
  transition: background 0.1s;

  &:disabled,
  &:disabled:hover {
    background: var(--spark-color-control-disabled-surface);
    color: var(--spark-color-control-disabled-text);
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled(Btn)`
  background: var(--spark-color-action-primary);
  color: var(--spark-color-on-action-primary);
  &:hover { background: var(--spark-color-action-primary-hover); }
`;

export const SecondaryButton = styled(Btn)`
  background: var(--spark-color-control-hover-surface);
  color: var(--spark-color-text-control);
  &:hover { background: var(--spark-color-control-hover-strong); }
`;

export const DangerButton = styled(Btn)`
  background: transparent;
  color: var(--spark-color-error-text);
  border: 1px solid var(--spark-color-error-text);
  margin-right: auto;

  &:hover {
    background: var(--spark-color-error-subtle-surface);
  }
`;

export const ErrorMsg = styled.div`
  color: var(--spark-color-error-text);
  ${font('md')}
  margin-bottom: 12px;
  padding: 8px 12px;
  background: var(--spark-color-error-subtle-surface);
  border-radius: 6px;
`;
